import { defineCountry } from '../../../src/domain/country/factory';
import * as languages from '../../languages';

export default defineCountry({
  countryName: 'UAE',
  countryCode: 'AE',
  countryHeaderCode: 'uae',
  mobileRegex: /^(?:0?5[0124568]\d{7})$/,
  mobileCode: '+971',
  mobileLength: 9,
  prefixesToRemove: ['0'],
  consentForCallback: {
    shouldShow: true,
  },
  languages: {
    [languages.en.languageCode]: {
      bookingFlowConfig: {
        isDesktopBkfEnabled: true,
        isMobileBkfEnabled: true,
      },
      defaultAgreedDocs: {
        tncUrl: '/en-AE/terms-of-service',
        privacyPolicyUrl: '/en-AE/privacy-policy',
      },
      currencyConfig: {
        currencyLocale: 'en-AE',
        currencyCode: 'AED',
        maxMinorDigits: 2,
        currencySymbol: 'AED',
      },
    },
  },
  defaultLanguage: languages.en,
  googleAutoCompletePlacesCode: 'ae',
  trackOrderContactSupportNumber: '+97144242323',
});
